import { render, staticRenderFns } from "./Generate.vue?vue&type=template&id=c6ec2594"
import script from "./Generate.vue?vue&type=script&lang=js"
export * from "./Generate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6ec2594')) {
      api.createRecord('c6ec2594', component.options)
    } else {
      api.reload('c6ec2594', component.options)
    }
    module.hot.accept("./Generate.vue?vue&type=template&id=c6ec2594", function () {
      api.rerender('c6ec2594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/term/Generate.vue"
export default component.exports